export * from './viewerManagerStructureApi'
export * from './viewerManagerDataApi'
export * from './beckyPropsInitialStore'
export * from './platform'
export * from './layoutDone'

export const CarmiInstance = Symbol('CarmiInstance')
export const isViewerFragmentSymbol = Symbol('isViewerFragment')
export const DataRequirementsCheckerSymbol = Symbol('DataRequirementsChecker')
export const PagesModelsRegistrarSymbol = Symbol('PagesModelsRegistrar')
